import React from 'react';
import './About.css';
import Image from '../../assets/me2.jpg';
// import Resume from '../../assets/resume.pdf';
import AboutBox from './AboutBox';

const About = () => {
    const downloadResume = () => {
        window.open('/resume-xalimov.pdf', '_blank');
    }

    return (
        <section className="about container section" id="about">
            <h2 className="section__title">About Me </h2>

            <div className="about__container grid">
                <img src={Image} alt="" className='about__img' />

                <div className="about__data grid">
                    <div className="about__info">
                        <p className="about__description">
                            Hello! I'm Khalimov Ahrorbek, and I'm based in Termez, Uzbekistan. I've built my technical foundation through intensive training at Billion School and IT Park, where I specialized in full-stack development and recently secured my 7.0 Academic IELTS score.<br /><br />
                            Fast-forward to today, and I can honestly say it's been a beautiful journey. My focus these days is on scaling digital solutions that address real-world problems and help people overcome everyday challenges as I continue my university education. I'm eager to keep growing as a Full Stack Developer and to keep pushing the boundaries of what I can build.<br /><br />
                            Here are a few technologies I’ve been working with recently:
                        </p>
                        <ul className="about__list">
                            <li>HTML, CSS</li>
                            <li>JavaScript</li>
                            <li>Tailwind CSS</li>
                            <li>Python and aiogram tg bots</li>
                            <li>Postgres SQL</li>
                            <li>React</li>
                        </ul>
                        {/* <button className="btn" onClick={downloadResume}>Download CV</button> */}
                    </div>

                    {/* <div className="about__skills grid">
                        <div className="skills__data">
                            <div className="skills__titles">
                                <h3 className="skills__name">Development</h3>
                                <span className="skills__number">90%</span>
                            </div>

                            <div className="skills__bar">
                                <span className="skills__percentage development">

                                </span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <div className="skills__titles">
                                <h3 className="skills__name">UI/UX Design</h3>
                                <span className="skills__number">80%</span>
                            </div>

                            <div className="skills__bar">
                                <span className="skills__percentage ui__design">

                                </span>
                            </div>
                        </div>

                        <div className="skills__data">
                            <div className="skills__titles">
                                <h3 className="skills__name">Photography</h3>
                                <span className="skills__number">60%</span>
                            </div>

                            <div className="skills__bar">
                                <span className="skills__percentage photography">

                                </span>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>

            <AboutBox />
        </section>
    )
}

export default About